/* eslint-disable no-unused-vars */
import React, {useContext} from 'react';
import './list-item.scss';
import {placeIdCall} from '../../services/api/api.utils';
import {useHistory} from 'react-router-dom';
import {MapContext} from '../../services/map-v2/map.context';
import {DataContext} from '../../services/data-v2/data.context';

export const ListAddressItem = (props: any) => {
    const {map} = useContext(MapContext);
    const history = useHistory();
    const {db} = useContext(DataContext);

    const goToLocation = async (id: string) => {
        let location: any = {};
        const place = await placeIdCall(id);
        location = place?.result?.geometry?.location;
        const data = await db?.dataSources?.searches.findOneById(place.result.place_id);
        !data && await db?.dataSources?.searches.insert({
            id: place.result.place_id, label: place.result.formatted_address, coords: location, createdAt: Date.now(),
        });
        history.push(`/serveis-aprop?type=0&lat=${location?.lat}&lng=${location?.lng}`);
        return location;
    };

    return <>
        {
            <button onClick={() => goToLocation(props.place_id)} className={'list-item'}>
                <div className="text">
                    <div className="title">{props.description} </div>
                </div>
            </button>

        }
    </>;
};
